import { render } from "./ManagerEditor.vue?vue&type=template&id=1fecd210"
import script from "./ManagerEditor.vue?vue&type=script&lang=js"
export * from "./ManagerEditor.vue?vue&type=script&lang=js"

import "./ManagerEditor.vue?vue&type=style&index=0&id=1fecd210&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__